import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Auth } from '@janiscommerce/sdk'
import { jwksUri, oauthClientId, oauthRedirectPath } from '../constants';

const options = {
	client_id: oauthClientId,
	redirect_uri: `${window.location.origin}${oauthRedirectPath}`
};

const authClient = new Auth(options);

const notLoggedState = {
	isLogged: false,
	isDev: false,
	isLoading: false
};

const useUserData = () => {

	const [userData, setUserData] = useState({ ...notLoggedState, isLoading: true });

  const [cookies] = useCookies();

  useEffect(() => {

		(async () => {
			const authCookie = cookies.auth;

			if(authCookie) {
				try {

					if(userData.firstname) {
						return;
					}

					const decodedToken = await authClient.decodeIdToken(authCookie, jwksUri);

					if(decodedToken) {
						setUserData({
							isLoading: false,
							isLogged: true,
							isDev: decodedToken.isDev,
							firstname: decodedToken.given_name,
							lastname: decodedToken.family_name,
							profilePicture: decodedToken.images.thumbnail
						});
					}
				} catch(e) {
					setUserData({ ...notLoggedState });
				}
			} else {
				if(userData.isLoading) {
					setUserData({
						...userData,
						isLoading: false
					});
				}
			}

			return;
		})();

	}, [cookies.auth, userData]);

	return userData;
};

export default useUserData;
